import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 10000;
  /* Reserve space on the right for the floating badges stack */
  margin-right: 70px;
  width: min(420px, calc(100vw - 2rem - 70px));
  pointer-events: auto;

  @media (max-width: 600px) {
    right: 0.75rem;
    left: 0.75rem;
    /* Sit ABOVE the floating badges on mobile so neither overlaps the other */
    bottom: calc(1rem + 4 * (42px + 8px));
    margin-right: 0;
    width: auto;
  }
`;

export const Card = styled.div`
  background: #f7f6f1;
  color: #1a1a1a;
  border-radius: 10px;
  padding: 1.1rem 1.15rem 1rem;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.35);
  font-family: 'Abel', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Title = styled.h2`
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  letter-spacing: 0.02em;
`;

export const Text = styled.p`
  font-size: 0.82rem;
  line-height: 1.45;
  color: #3a3a3a;
  margin: 0;

  a {
    color: #657455;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Categories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 0.7rem 0;
`;

export const Category = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  font-size: 0.85rem;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.75 : 1)};

  strong {
    display: block;
    font-weight: 600;
    font-size: 0.9rem;
  }

  small {
    color: #666;
    font-size: 0.72rem;
    line-height: 1.35;
    display: block;
    margin-top: 0.1rem;
  }
`;

export const Toggle = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 34px;
  height: 18px;
  border-radius: 10px;
  background: #ccc;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    transition: transform 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  &:checked { background: #657455; }
  &:checked::after { transform: translateX(16px); }
  &:disabled { cursor: not-allowed; opacity: 0.6; }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 480px) {
    flex-direction: row;
    gap: 0.55rem;
  }
`;

export const PrimaryBtn = styled.button`
  flex: 1;
  background: #b8964a;
  color: #fff;
  border: none;
  padding: 0.65rem 0.9rem;
  border-radius: 6px;
  font-family: 'Abel', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  cursor: pointer;
  text-transform: uppercase;
  transition: background 0.2s ease;

  &:hover { background: #a07f3a; }
`;

export const SecondaryBtn = styled.button`
  flex: 1;
  background: transparent;
  color: #1a1a1a;
  border: 1px solid #1a1a1a;
  padding: 0.65rem 0.9rem;
  border-radius: 6px;
  font-family: 'Abel', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  cursor: pointer;
  text-transform: uppercase;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover { background: #1a1a1a; color: #fff; }
`;

export const LinkBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #657455;
  cursor: pointer;
  font-size: 0.8rem;
  text-decoration: underline;
  font-family: 'Abel', sans-serif;
  align-self: flex-start;
`;
